module.exports = __webpack_public_path__ + "img/logo-lc-internet.178ca758.svg";